// extracted by mini-css-extract-plugin
module.exports = {"mini-card":"MiniCard_mini-card__2wOI1","mini-card__number":"MiniCard_mini-card__number__TCTYO","mini-card--disabled":"MiniCard_mini-card--disabled__gZehM"};